(function () {
  function paymentTermsHost(item) {
    return item.querySelector('shopify-payment-terms, #shopify-installments');
  }

  function paymentTermsVisible(item, host, allowPending) {
    if (!host) {
      return false;
    }

    item.hidden = false;

    var style = window.getComputedStyle(host);
    if (style.display === 'none' || style.visibility === 'hidden') {
      return false;
    }

    if (host.getBoundingClientRect().height > 0) {
      return true;
    }

    return Boolean(allowPending);
  }

  function syncPaymentTerms(scope, allowPending) {
    (scope || document).querySelectorAll('.td-product-price > [data-block-type="payment-terms"]').forEach(function (item) {
      var host = paymentTermsHost(item);
      item.hidden = !paymentTermsVisible(item, host, allowPending);
      observeHost(item);
    });
  }

  function observeHost(item) {
    var host = paymentTermsHost(item);
    if (!host || item.dataset.tdPaymentTermsObserved === 'true') {
      return;
    }

    item.dataset.tdPaymentTermsObserved = 'true';

    if (typeof ResizeObserver === 'function') {
      var observer = new ResizeObserver(function () {
        item.hidden = !paymentTermsVisible(item, host, true);
      });
      observer.observe(host);
    }
  }

  function scheduleSync(scope) {
    requestAnimationFrame(function () {
      syncPaymentTerms(scope, true);
    });
    setTimeout(function () {
      syncPaymentTerms(scope, true);
    }, 120);
    setTimeout(function () {
      syncPaymentTerms(scope, false);
    }, 800);
  }

  document.addEventListener('DOMContentLoaded', function () {
    scheduleSync();
  });
  window.addEventListener('load', function () {
    scheduleSync();
  });
  document.addEventListener('shopify:section:load', function (event) {
    scheduleSync(event.target);
  });
  document.addEventListener('change', function (event) {
    if (event.target && event.target.closest && event.target.closest('.td-product-price [data-block-type="payment-terms"]')) {
      scheduleSync();
    }
  });

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('shopify-payment-terms').then(function () {
      scheduleSync();
    }).catch(function () {});
  }
})();
